import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../api";
import { RUBRIQUES } from "../rubriques";
import { Plus, X, Lock, Shield } from "lucide-react";

const DUREES = [
  { v: 1, label: "24 heures" },
  { v: 7, label: "7 jours" },
  { v: 30, label: "30 jours" },
];

export default function Partages() {
  const [partages, setPartages] = useState([]);
  const [plan, setPlan] = useState(null);
  const [error, setError] = useState("");
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ destinataire: "", rubriques: [], duree_jours: 7 });

  const load = async () => {
    const { data } = await api.get("/carnet");
    setPartages(data.partages);
    setPlan(data.plan);
  };
  useEffect(() => { load(); }, []);

  const toggleRubrique = (id) => {
    setForm((f) => ({
      ...f,
      rubriques: f.rubriques.includes(id) ? f.rubriques.filter((x) => x !== id) : [...f.rubriques, id],
    }));
  };

  const create = async () => {
    setError("");
    if (!form.destinataire || form.rubriques.length === 0) {
      setError("Veuillez renseigner un email et sélectionner au moins une rubrique.");
      return;
    }
    try {
      await api.post("/partages", form);
      setForm({ destinataire: "", rubriques: [], duree_jours: 7 });
      setCreating(false);
      load();
    } catch (e) {
      setError(formatApiError(e));
    }
  };

  const revoke = async (id) => {
    if (!window.confirm("Révoquer ce partage ?")) return;
    await api.post(`/partages/${id}/revoke`);
    load();
  };

  if (!plan) return <div>Chargement…</div>;
  const locked = plan.id !== "confort";

  return (
    <div className="space-y-8">
      <div>
        <div style={{ color: "var(--auprea-gold)", fontSize: 12, letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 600, marginBottom: 12 }}>
          — Lecture seule, durée limitée
        </div>
        <h1 style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }} data-testid="partages-title">Partages aux professionnels</h1>
        <p style={{ fontSize: 17, color: "rgba(35,38,46,0.7)", marginTop: 8 }}>
          Donnez un accès temporaire à votre notaire, votre conseiller ou un proche.
        </p>
      </div>

      {locked ? (
        <div className="auprea-card" style={{ borderColor: "var(--auprea-gold)", backgroundColor: "#faf4e8" }}>
          <Lock size={28} color="#caa86a" />
          <h3 style={{ fontSize: 22, margin: "12px 0 8px" }}>Partages réservés au forfait Confort</h3>
          <p>Passez au forfait Confort pour partager votre carnet en lecture seule.</p>
          <a href="/tarifs"><button className="auprea-btn-gold mt-4" data-testid="btn-partage-upgrade">Voir le forfait Confort</button></a>
        </div>
      ) : (
        <>
          {!creating && (
            <button onClick={() => setCreating(true)} className="auprea-btn" data-testid="btn-new-partage">
              <Plus size={18} style={{ marginRight: 8 }} /> Nouveau partage
            </button>
          )}

          {creating && (
            <div className="auprea-card space-y-4">
              <div className="flex items-center justify-between">
                <h3 style={{ fontSize: 22 }}>Créer un partage</h3>
                <button onClick={() => setCreating(false)}><X size={20} /></button>
              </div>
              <div>
                <label className="auprea-label">Email du destinataire</label>
                <input type="email" className="auprea-input" value={form.destinataire} onChange={(e) => setForm({ ...form, destinataire: e.target.value })} placeholder="notaire@etude.fr" data-testid="input-partage-email" />
              </div>
              <div>
                <label className="auprea-label">Rubriques partagées</label>
                <div className="grid grid-cols-2 gap-2 mt-2">
                  {RUBRIQUES.map((r) => (
                    <label key={r.id} className="flex items-center gap-2 cursor-pointer p-2" style={{ border: "1px solid rgba(21,41,79,0.15)" }} data-testid={`checkbox-rub-${r.id}`}>
                      <input type="checkbox" checked={form.rubriques.includes(r.id)} onChange={() => toggleRubrique(r.id)} />
                      <span style={{ fontSize: 14 }}>{r.label}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <label className="auprea-label">Durée d'accès</label>
                <div className="flex gap-3">
                  {DUREES.map((d) => (
                    <label key={d.v} className="flex items-center gap-2 cursor-pointer">
                      <input type="radio" name="duree" checked={form.duree_jours === d.v} onChange={() => setForm({ ...form, duree_jours: d.v })} data-testid={`radio-duree-${d.v}`} />
                      <span>{d.label}</span>
                    </label>
                  ))}
                </div>
              </div>
              {error && <div style={{ color: "#b53a3a", fontSize: 14 }} data-testid="partage-error">{error}</div>}
              <button onClick={create} className="auprea-btn" data-testid="btn-save-partage">Créer le partage</button>
            </div>
          )}

          <div>
            <h2 style={{ fontSize: 22, marginBottom: 16 }}>Partages actifs ({partages.filter((p) => p.actif).length})</h2>
            {partages.length === 0 ? (
              <div className="auprea-card text-center" style={{ color: "rgba(35,38,46,0.6)" }} data-testid="partages-empty">
                Aucun partage. Créez votre premier partage ci-dessus.
              </div>
            ) : (
              <div className="space-y-2">
                {partages.map((p) => (
                  <div key={p.id} className="auprea-card flex items-center justify-between gap-4" style={{ padding: 20 }} data-testid={`partage-${p.id}`}>
                    <div className="flex items-start gap-4 min-w-0">
                      <Shield size={24} color={p.actif ? "var(--auprea-green)" : "rgba(35,38,46,0.4)"} style={{ flexShrink: 0, marginTop: 2 }} />
                      <div className="min-w-0">
                        <div style={{ fontWeight: 500 }}>{p.destinataire_email}</div>
                        <div style={{ fontSize: 13, color: "rgba(35,38,46,0.7)" }}>
                          {p.rubriques.length} rubrique(s) · Expire le {new Date(p.expiration).toLocaleDateString("fr-FR")}
                        </div>
                        <div style={{ fontSize: 12, marginTop: 4, color: p.actif ? "var(--auprea-green)" : "#b53a3a" }}>
                          {p.actif ? "Actif" : "Révoqué"}
                        </div>
                      </div>
                    </div>
                    {p.actif && (
                      <button onClick={() => revoke(p.id)} className="auprea-btn-outline" style={{ padding: "8px 14px", minHeight: "auto", fontSize: 14 }} data-testid={`btn-revoke-${p.id}`}>
                        Révoquer
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
